import { createReducer } from "actionware";
import { createState } from "stateware";
import { toggleConfirmationModal } from "./confirmationModalActions";
import { modalPopupStates } from "../../common/constants";

const initialState = createState({
  showingConfirmationModal: false,
  action: modalPopupStates.confirmAllocation,
});

export default createReducer(initialState).on(
  toggleConfirmationModal,
  (state, action) => {
    return initialState.copy({
      ...state,
      showingConfirmationModal: !state.showingConfirmationModal,
      action: action,
    });
  }
);
